const styles = {
  versionDetails: {
    position: 'relative',
    height: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 75px)' },
    padding: 2,
    boxSizing: 'border-box',
    backgroundColor: '#f0f0f0',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    gap: 2,
  },

  headerRow: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  pageTitle: {
    fontFamily: 'Source Sans Pro',
    fontWeight: 600,
    fontSize: { xs: '28px', sm: '38px' },
    lineHeight: '100%',
    color: '#5236AB',
  },

  viewToggle: { display: 'flex', alignItems: 'center', gap: 1 },
  viewToggleButtonActive: {
    width: '52px',
    height: '48px',
    border: '1px solid #5236AB',
    padding: '8px 16px',
    backgroundColor: '#5236AB',
    color: '#fff',
    borderRadius: 0,
  },
  viewToggleButtonInactive: {
    width: '50px',
    height: '48px',
    border: '1px solid #5236AB',
    padding: '8px 16px',
    backgroundColor: '#fff',
    color: '#5236AB',
    borderRadius: 0,
  },
};

export default styles;
